/**
 * THE SHOP THE TAB IS ON, FOR WHAT LIVES OUTSIDE ITS PAGES (DK parity, S1d).
 *
 * The floating help button is mounted once, beside the cart bar in App.js, not
 * inside a page — so it cannot read the salon a page loaded. Every shop page
 * loads its business through `getSalonBySlug` / `getSalonByHost`, and both pass
 * through `noteShopVisit` (api/storeApi.js), which remembers it here. The product
 * page remembers the product it shows while it shows it.
 *
 * What is remembered is only a hint: the button still checks the address is the
 * remembered shop's own page (utils/shopSurface), so a shop loaded a moment ago
 * can never lend its button to another business's page.
 */
import { useSyncExternalStore } from 'react';

let shop = null;
let productName = null;
const listeners = new Set();

const emit = () => listeners.forEach((listener) => listener());
const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export function rememberCurrentShop(salon) {
  const next = salon || null;
  if (next === shop) return;
  shop = next;
  emit();
}

export function rememberCurrentProductName(name) {
  const next = (typeof name === 'string' && name.trim()) ? name.trim() : null;
  if (next === productName) return;
  productName = next;
  emit();
}

export const currentShop = () => shop;
export const currentProductName = () => productName;

export function useCurrentShop() {
  return useSyncExternalStore(subscribe, currentShop, () => null);
}

export function useCurrentProductName() {
  return useSyncExternalStore(subscribe, currentProductName, () => null);
}

/** Tests only: forget both. */
export function __resetCurrentShop() {
  shop = null;
  productName = null;
  emit();
}
